// extracted by mini-css-extract-plugin
export default {"root":"Snackbar_root__MFs1N","success":"Snackbar_success__dS5D2","error":"Snackbar_error__26oat","warning":"Snackbar_warning__QM9cU","alert":"Snackbar_alert__8AQi4"};